import { defineCustomElement } from 'vue';
import VueAcreCookieConsent from './AcreCookieConsent.vue';

export { VueAcreCookieConsent };
export const AcreCookieConsent = defineCustomElement(VueAcreCookieConsent);

export function registerCookieConsent(name = 'acre-cookie-consent') {
  if (!customElements.get(name)) {
    customElements.define(name, AcreCookieConsent);
  }
}

registerCookieConsent();
